// extracted by mini-css-extract-plugin
module.exports = {"product":"_212ITo","shine-lines":"_2ksMVI"};